// src/scenes/groups/form.jsx
import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

const GroupForm = ({ open, onClose, formData, setFormData, onSubmit }) => {
  useEffect(() => {
    if (!open) {
      setFormData({
        name: "",
        description: "",
        logoPath: null,
      });
    }
  }, [open, setFormData]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Create New Group</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Group Name"
          margin="dense"
          value={formData.name || ""}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        <TextField
          fullWidth
          label="Description"
          margin="dense"
          multiline
          minRows={3}
          value={formData.description || ""}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
        />
        <TextField
          fullWidth
          label="Logo Path (optional)"
          margin="dense"
          value={formData.logoPath ?? ""}
          onChange={(e) =>
            setFormData({ ...formData, logoPath: e.target.value || null })
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupForm;
